import { Route, Routes } from 'react-router-dom';
import RegionListPage from './list';

export default function RegionRouting() {
  return (
    <Routes>
      <Route index element={<RegionListPage />} />
    </Routes>
  );
}
